import { SearchObserver } from './search.observer'
import { ClearSearchObserver } from './clearSearch.observer'
import { EnterSearchObserver } from './enterSearch.observer'
import { HistorySearchObserver } from './historySearch.observer'
import { SearchService } from './search.service'
import { Observable, BehaviorSubject } from 'rxjs'

export class SearchComponent {

    constructor() {
      this.searchFieldElement = document.querySelector(".autocomplete-input")
      this.searchButton = document.querySelector(".topbar-search__icon--search")
      this.itemTagPrice = document.querySelectorAll(".item-tag--pack-price .price")
      this.service = new SearchService()
      this.init()
    }

    init() {

        if(this.itemTagPrice){
            // const [int, dec] = this.itemTagPrice[0].textContent.trim().split('.');
            if(this.itemTagPrice) {

                Array.prototype.forEach.call(this.itemTagPrice, item => {
                    let itemReplace = item.textContent.replace('.', ',')
                    const [int, dec] = itemReplace.trim().split(',');
                    item.outerHTML = `
                    <span class="valorInt">${int}</span>
                    <span class="valorDec">,${dec}</span>
                    `;
                  }); 
            }
        }

        if(this.searchFieldElement && this.searchButton) {
            let keyupStream = Observable.fromEvent(this.searchFieldElement, 'keyup');
            let clickStream = Observable.fromEvent(this.searchButton, 'click');
            let enterSubject = new BehaviorSubject();
            enterSubject.subscribe(new HistorySearchObserver())
            enterSubject.subscribe(new EnterSearchObserver())

            //clear on input empty
            keyupStream
                .filter(e => e.keyCode === 8)
                .map(e => e.target.value)
                .filter(termo => termo.length === 0)
                .subscribe(new ClearSearchObserver())

            //input search event
            keyupStream
                .debounceTime(400)
                .map(e => e.target.value)
                .distinctUntilChanged()
                .filter((termo) => termo.length >= 3)
                .subscribe((termo) => this.autocomplete(termo))

            //enter search event
            keyupStream
                .filter(e => e.keyCode === 13)
                .map(e => e.target.value)
                .filter((termo) => termo.length >= 2)
                .subscribe(termo => enterSubject.next(termo))

            //click search event
            clickStream
                .map((e) => this.searchFieldElement.value)
                .filter((termo) => termo.length >= 2)
                .subscribe(termo => enterSubject.next(termo))
        }
    }

    autocomplete(termo) {
        return this.service
                .autocomplete(termo)
                .subscribe(new SearchObserver(termo));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/search/search.component.js